var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolarPanels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85.542,
    height: 85.238,
    viewBox: "0 0 85.542 85.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24479",
    "data-name": "Rectangle 24479",
    width: 85.542,
    height: 85.238,
    fill: "#fe6831"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63676",
    "data-name": "Group 63676",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75449",
    "data-name": "Path 75449",
    d: "M23.8,44.558V80.964c.174.108.269.213.373.224,1.087.11,2.489-.045,2.457,1.543C26.6,84.408,25.178,84.256,24,84.256c-3.088,0-6.176.014-9.262-.007-1.194-.009-2.839.3-2.757-1.491.032-.7,1.413-1.333,2.179-2l.5.4V35.379c-4.3-.963-8.515-1.848-12.686-2.893C1.228,32.3.653,31.449,0,30.9c.663-.606,1.242-1.586,2-1.757,4.383-.981,8.8-1.854,13.229-2.57a3.736,3.736,0,0,0,2.5-1.529c2.851-3.4,5.75-6.762,8.74-10.038a2.811,2.811,0,0,1,2.315-.824c1.219.365.92,1.555.59,2.521-1.428,4.193-2.808,8.4-4.352,12.553a3.943,3.943,0,0,0-.026,3.1c1.6,4.26,3.045,8.579,4.428,12.915.194.608-.111,1.915-.482,2.044a2.774,2.774,0,0,1-2.244-.449A19.784,19.784,0,0,1,24.233,44.2l-.433.358M20.73,81.185V78.494c0-11.912-.075-23.824.064-35.734.029-2.5-1.413-3.778-2.874-5.539V81.185ZM14.742,29.567l-6.6,1.019c-.012.146-.022.292-.034.438l6.629,1.07ZM24.5,40.433l.462-.2L22.558,34l-2.15,1.349,4.1,5.084m-4.144-14.1,2.226,1.295c.81-2.118,1.581-4.134,2.352-6.15l-.42-.234-4.157,5.09m.931,4.538c-.909-.671-1.451-1.384-1.95-1.355-.528.031-1.016.766-1.522,1.193.476.523.882,1.333,1.454,1.475.424.105,1.064-.655,2.017-1.313",
    transform: "translate(0 0.926)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75450",
    "data-name": "Path 75450",
    d: "M57.921,72.276v6a4.363,4.363,0,0,0,.875.182c1.112,0,2.067.3,1.975,1.608-.091,1.288-1.137,1.422-2.195,1.417-2.281-.012-4.563,0-6.845,0-1.172,0-2.343-.016-3.515,0-1.067.017-2.1-.148-2.191-1.425-.093-1.3.868-1.611,1.98-1.6a7.672,7.672,0,0,0,.929-.123c0-4.131-.124-8.249.049-12.355.1-2.271-.365-4.064-2.253-5.438a5.761,5.761,0,0,1-1.756-1.871,2.04,2.04,0,0,1,.1-1.892c.36-.346,1.274-.177,1.935-.112.243.023.46.384.678.6q7.523,7.52,15.042,15.041c.218.218.573.43.6.678.081.657.266,1.71-.043,1.914a2.2,2.2,0,0,1-2.043.072,26.079,26.079,0,0,1-2.886-3.034l-.441.332m-5.867-6.219V78.375h2.809a66.706,66.706,0,0,1,.056-7.254c.272-2.447-1.155-3.628-2.865-5.064",
    transform: "translate(2.933 3.704)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75451",
    "data-name": "Path 75451",
    d: "M76.071,71.677V78.34a3.145,3.145,0,0,1,1.2.189,14.944,14.944,0,0,1,1.644,1.385c-.565.527-1.1,1.464-1.7,1.51-2.332.178-4.686.071-7.031.072-1.3,0-2.592,0-3.889.013-1.069.012-2.1-.168-2.168-1.453-.067-1.306.911-1.588,2.015-1.573a6.864,6.864,0,0,0,.881-.119c0-5.078.043-10.124-.056-15.167-.012-.581-.77-1.183-1.253-1.711-.706-.774-1.476-1.491-2.22-2.229-.765-.759-1.338-1.6-.349-2.532s1.785-.288,2.536.465q6.15,6.16,12.311,12.3a33.21,33.21,0,0,1,3.216,3.316c.386.512.163,1.483.217,2.245-.764-.056-1.724.158-2.249-.225a27.077,27.077,0,0,1-3.106-3.152m-3.093,6.75a64.581,64.581,0,0,1,.055-7.144c.286-2.494-1.067-3.786-3-5.3V78.427Z",
    transform: "translate(4.1 3.684)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75452",
    "data-name": "Path 75452",
    d: "M30.832,78.35c0-5.094.02-10.022-.033-14.949a2.438,2.438,0,0,0-.741-1.376A44.179,44.179,0,0,1,27,58.822c-.349-.468-.086-1.394-.1-2.111.717.01,1.434.017,2.151.034.047,0,.094.076.137.119,5.278,5.277,10.58,10.531,15.79,15.876a2.3,2.3,0,0,1,.207,2.192c-.642.965-1.612.608-2.34-.17-.873-.933-1.722-1.886-2.582-2.83l-.374.257V78.3c.362.053.855-.012,1.148.2A16.453,16.453,0,0,1,42.7,80.044c-.614.474-1.2,1.311-1.843,1.358-2.271.168-4.56.066-6.844.067a25.028,25.028,0,0,1-4.061-.061c-.739-.124-1.834-.772-1.963-1.36-.271-1.24.779-1.614,1.9-1.6a9.185,9.185,0,0,0,.939-.1m5.934.049a68.327,68.327,0,0,1,.053-7.153c.265-2.474-1-3.814-2.98-5.22V78.4Z",
    transform: "translate(1.756 3.713)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75453",
    "data-name": "Path 75453",
    d: "M47.3,16.475a7.424,7.424,0,1,1,14.847-.167,7.424,7.424,0,0,1-14.847.167m7.466-4.524A4.386,4.386,0,0,0,50.3,16.394a4.422,4.422,0,1,0,8.842-.1,4.407,4.407,0,0,0-4.381-4.34",
    transform: "translate(3.097 0.586)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75454",
    "data-name": "Path 75454",
    d: "M50.788,6.585c-.576.619-.908,1.271-1.376,1.392a1.8,1.8,0,0,1-1.583-.49,50.012,50.012,0,0,1-3.145-5.393,2.08,2.08,0,0,1,.5-1.737c.231-.276,1.292-.34,1.446-.123,1.428,2.032,2.74,4.145,4.163,6.351",
    transform: "translate(2.922 0.007)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75455",
    "data-name": "Path 75455",
    d: "M62.693,0a1.539,1.539,0,0,1,1.492,2.169,48.788,48.788,0,0,1-3.071,5.225,1.936,1.936,0,0,1-1.842.476,1.917,1.917,0,0,1-.662-1.779A56.89,56.89,0,0,1,61.7.667c.225-.362.771-.525.993-.667",
    transform: "translate(3.834)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75456",
    "data-name": "Path 75456",
    d: "M46.451,10.349a1.437,1.437,0,0,1-2.132,1.506A48.351,48.351,0,0,1,39.25,8.9a1.97,1.97,0,0,1-.624-1.79c.189-.455,1.311-1,1.685-.821,1.969.966,3.843,2.131,5.717,3.281.259.159.336.613.423.784",
    transform: "translate(2.526 0.409)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75457",
    "data-name": "Path 75457",
    d: "M64.083,12.4c-.595-.482-1.221-.743-1.349-1.157-.151-.492-.074-1.425.25-1.633A66.864,66.864,0,0,1,68.85,6.24a1.585,1.585,0,0,1,1.4.524c.265.348.349,1.32.128,1.477-2.022,1.435-4.13,2.751-6.3,4.159",
    transform: "translate(4.103 0.406)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75458",
    "data-name": "Path 75458",
    d: "M39.269,26.719a6.34,6.34,0,0,1-.715-1.757,2.018,2.018,0,0,1,.479-1.6,54.521,54.521,0,0,1,5.442-3.137,1.735,1.735,0,0,1,1.6.416c.3.36.38,1.46.134,1.632-2.005,1.4-4.111,2.664-6.945,4.446",
    transform: "translate(2.524 1.32)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75459",
    "data-name": "Path 75459",
    d: "M71.005,25.005c-.946.353-1.865,1.045-2.361.818a37.917,37.917,0,0,1-5.548-3.2,2.009,2.009,0,0,1-.224-1.9,1.789,1.789,0,0,1,1.7-.489,61.365,61.365,0,0,1,5.409,3.093c.356.221.5.784,1.027,1.677",
    transform: "translate(4.108 1.321)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75460",
    "data-name": "Path 75460",
    d: "M46.336,32.17C44.87,32.2,44.143,31.117,44.723,30a42.2,42.2,0,0,1,2.992-5.056,2.188,2.188,0,0,1,1.976-.505,1.933,1.933,0,0,1,.558,1.789,56.144,56.144,0,0,1-3,5.261,2.681,2.681,0,0,1-.91.685",
    transform: "translate(2.915 1.596)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75461",
    "data-name": "Path 75461",
    d: "M60.2,24.145a4.675,4.675,0,0,1,1.137,1A35.256,35.256,0,0,1,63.981,29.8c.253.576-.229,1.475-.376,2.227-.695-.214-1.7-.213-2.028-.684a41.1,41.1,0,0,1-2.886-4.94c-.588-1.141.074-2.25,1.511-2.253",
    transform: "translate(3.829 1.581)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75462",
    "data-name": "Path 75462",
    d: "M55.855,3.767c0,.428.164.973-.036,1.259-.4.574-.955,1.283-1.55,1.4-.361.071-1.16-.787-1.333-1.358a4.5,4.5,0,0,1-.015-2.531c.23-.721.844-1.7,1.45-1.837,1.129-.247,1.5.745,1.486,1.783,0,.428,0,.856,0,1.284",
    transform: "translate(3.454 0.043)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75463",
    "data-name": "Path 75463",
    d: "M41.924,14.5c.3,0,.611.01.915,0,1.1-.039,2.155.308,1.944,1.529-.1.583-1.157,1.138-1.889,1.432a2.878,2.878,0,0,1-1.976,0c-.727-.3-1.73-.845-1.866-1.451-.245-1.1.721-1.517,1.773-1.5.365.007.732,0,1.1,0Z",
    transform: "translate(2.555 0.949)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75464",
    "data-name": "Path 75464",
    d: "M67.054,14.519c.427,0,.946-.156,1.263.033a11.5,11.5,0,0,1,1.616,1.379c-.5.521-.907,1.312-1.507,1.5a4.8,4.8,0,0,1-2.706.012c-.658-.2-1.144-.967-1.707-1.483a14.049,14.049,0,0,1,1.777-1.406c.322-.184.836-.032,1.264-.033",
    transform: "translate(4.191 0.947)",
    fill: "#fe6831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75465",
    "data-name": "Path 75465",
    d: "M55.865,28.707c0,.367.137.819-.028,1.081A17.816,17.816,0,0,1,54.4,31.576c-.51-.565-1.227-1.053-1.472-1.716a3.629,3.629,0,0,1-.014-2.338,7.3,7.3,0,0,1,1.5-1.858,13.907,13.907,0,0,1,1.407,1.779c.185.322.032.836.032,1.264Z",
    transform: "translate(3.453 1.68)",
    fill: "#fe6831"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanels);
export default __webpack_public_path__ + "static/media/solar-panels.07b5aa1b02b844dd666746912164d59a.svg";
export { ForwardRef as ReactComponent };